/** @jsxImportSource @emotion/react */
import React, { ReactElement } from 'react'
import * as classes from './styles'

export type FiltersWrapperProps = {
  children: ReactElement | ReactElement[]
  className?: string
}

export const FiltersWrapper = ({ children, className }: FiltersWrapperProps) => (
  <div css={classes.filtersWrapper} className={className}>
    {children}
  </div>
)
